export const environment = {
    production: false,
    enableHttpInterceptors: true
}
